import { Observable } from 'rxjs/Observable';
import {
    Component,
    ElementRef,
    OnInit,
    ViewChild,
    ViewContainerRef
} from "@angular/core";
import { Router } from "@angular/router";
import { overlayConfigFactory } from "angular2-modal";
import { BSModalContext, Modal } from "angular2-modal/plugins/bootstrap";
import { TranslateService } from "ng2-translate/ng2-translate";
import {
    AdditionalInfo,
    BeneficiaryDetails,
    CardDetails,
    PaymentDetails,
    SendMoneyDetail,
    SendMoneySteps,
    StoreDetails,
    SummaryDetails,
    AdditionalRequired
} from "../../models/sendmoney/sendmoney";
import { AlertService } from "../../sharedcomponents/commonservice/alert.service";
import { CountryService } from "../../sharedcomponents/commonservice/countrylist.service";
import { utilityService } from "../../sharedcomponents/commonservice/utility.service";
import {
    AppSettings,
    PaymentType,
    enumStatusCodeList
} from "../../sharedcomponents/_common/constants/app.constants";
import { AlertPopupComponent } from "../../sharedcomponents/_directive/alert-popup/alert-popup.component";
import { ErrorPopupComponent } from "../../sharedcomponents/_directive/error-popup/error-popup.component";
import {
    AmountFormat,
    MyCurrencyPipe
} from "../../sharedcomponents/_pipe/mycurreny";
import { SendMoneyService } from "../../_services/sendmoneyservice/sendmoneyservice";
import { AddEditBeneficiaryComponent } from "../_add-edit-beneficiary/add-edit-beneficiary.component";
import { User } from "../../models/user/user";
import { AuthService } from "../../_services/userservice/auth.service";
import { UserStateService } from "../../_services/userservice/userstateservice";
import { AdditionalInfoPopupComponent } from "app/sendmoney/_modalpopup/additional-info-popup/additional-info-popup.component";
import { Subject } from "rxjs";

@Component({
    selector: "app-beneficiary",
    templateUrl: "./beneficiary.component.html",
    styleUrls: ["./beneficiary.component.css"],
    providers: [
        AlertService,
        Modal,
        CountryService,
        MyCurrencyPipe,
        AmountFormat,
        AuthService
    ]
})
export class BeneficiaryComponent implements OnInit {
    @ViewChild("scrollMe")
    private myScrollContainer: ElementRef;
    sendMoneyDetail: SendMoneyDetail;
    paymentDetails: PaymentDetails;
    model: any = {};
    beneficiaryData: any;
    beneficiaryList: any = [];
    srcRadio: boolean;
    dstRadio: boolean;
    Rate: number;
    Fee: number;
    TaxAmount: number;
    isFirstLoad = true;
    isModalOpen = false;
    appSettings: any;
    countrycollection = [];
    RoundingPlaces: number = AppSettings.fractionDigit;
    phoneLength: number = AppSettings.phoneminLength;
    private subUserDetails = new Subject<boolean>();
    observableUserDetails = this.subUserDetails.asObservable();
    private clickStream = new Subject<boolean>();
    observable = this.clickStream.asObservable();
    srcAmount: any;
    constructor(
        private router: Router,
        private modal: Modal,
        private alertService: AlertService,
        private countryserv: CountryService,
        private sendMoneyService: SendMoneyService,
        public utilityServ: utilityService,
        public translate: TranslateService,
        private currencyPipe: MyCurrencyPipe,
        private vcRef: ViewContainerRef,
        private amountFormat: AmountFormat,
        private auth: AuthService,
        private userStateService: UserStateService
    ) {
        this.sendMoneyDetail = new SendMoneyDetail();
        this.sendMoneyService.getSendMoneyDetailData().subscribe(data => {
            this.sendMoneyDetail = data;
        });
        this.sendMoneyService.getSendMoneyProgramDetailData().subscribe(data => {
            if (data.FromPage == "default") {
                return;
            }
            this.sendMoneyDetail.paymentDetails.srcAmount = this.sendMoneyDetail.sendMoneyProgramDetail.srcAmount;
            this.sendMoneyDetail.agentDetails.ProgramId = Number(
                this.sendMoneyDetail.sendMoneyProgramDetail.ProgramId
            );
        });
        this.sendMoneyDetail.beneficiaryDetails = new BeneficiaryDetails();
        this.sendMoneyDetail.summaryDetails = new SummaryDetails();
        this.sendMoneyDetail.storeDetails = new StoreDetails();
        this.sendMoneyDetail.cardDetails = new CardDetails();
        // this.sendMoneyDetail.paymentDetails = new PaymentDetails();
        this.sendMoneyDetail.additionalInfo = new AdditionalInfo();

        this.appSettings = AppSettings;

        this.paymentDetails = this.sendMoneyDetail.paymentDetails;
        // this.paymentDetails.destAmount = 0;
        // this.paymentDetails.srcAmount = 0;

        this.countrycollection = this.countryserv.getCountryListFromLocaleEx();
        const conObj = this.countrycollection.filter(
            item =>
                item.CountryCode ==
                this.sendMoneyDetail.pickupTypeDetails.countryPreference
        );
        if (conObj.length > 0) {
            const curobj = conObj[0].Currencies.filter(
                item =>
                    item.CurrencyCode == this.sendMoneyDetail.agentDetails.CurrencyTo
            );

            if (curobj.length > 0) {
                this.RoundingPlaces = curobj[0].RoundingPlaces;
            }
        }

        // this.RoundingPlaces = 4;
        //console.log("beneficiary.component.ts");
        this.model.srcAmount = this.currencyPipe.parse(this.paymentDetails.srcAmount.toString());
        this.model.destAmount = this.currencyPipe.parse(this.paymentDetails.destAmount.toString());
        this.paymentDetails.processingFee = parseFloat(this.sendMoneyDetail.branchDetails.CustomerFee.toString());
        this.paymentDetails.TaxAmount = parseFloat(this.sendMoneyDetail.branchDetails.TaxAmount.toString());
        this.paymentDetails.exchangeRate = this.sendMoneyDetail.branchDetails.RateCustomer.toString();
        this.Rate = Number(this.paymentDetails.exchangeRate);
        this.Fee = Number(this.paymentDetails.processingFee);
        this.TaxAmount = Number(this.paymentDetails.TaxAmount);

        if (this.sendMoneyDetail.branchDetails.MinimumDenomination != null) {
            this.paymentDetails.minimumDenomination = parseFloat(
                this.sendMoneyDetail.branchDetails.MinimumDenomination.toString()
            );
        } else {
            this.paymentDetails.minimumDenomination = 0;
        }

        if (this.sendMoneyDetail.branchDetails.MaximumLocalAmount != null) {
            this.paymentDetails.maxAllowedLimit = parseFloat(
                this.sendMoneyDetail.branchDetails.MaximumLocalAmount.toString()
            );
        } else {
            this.paymentDetails.maxAllowedLimit = 0;
        }

        if (
            !this.sendMoneyDetail.branchDetails.MaximumLocalAmountExcludeFee &&
            this.paymentDetails.maxAllowedLimit > 0
        ) {
            this.paymentDetails.maxAllowedLimit =
                this.paymentDetails.maxAllowedLimit - this.Fee;
        }

        if (
            this.paymentDetails.maxAllowedLimit == 0 ||
            this.paymentDetails.maxAllowedLimit >
            parseFloat(this.sendMoneyDetail.userDetails.maxTransferAmountLimit)
        ) {
            this.paymentDetails.maxAllowedLimit = parseFloat(
                this.sendMoneyDetail.userDetails.maxTransferAmountLimit
            );
        }

        this.paymentDetails.destCurrCode = this.sendMoneyDetail.pickupCenterDetails.Currency;
    }

    ngOnInit() {
        this.Init();
        this.valueChangeForward(true);
    }
    Init() {
        this.getBeneficiary();
        this.srcRadio = true;
        this.dstRadio = false;
    }
    getBeneficiary() {
        this.utilityServ.busy = this.sendMoneyService
            .getBeneficiaryList()
            .subscribe(
                data => {
                    this.isFirstLoad = false;
                    if (
                        data.Envelope.Body.BeneficiariesResponse.Beneficiaries
                            .BeneficiaryDetail !== undefined
                    ) {
                        const arrlist: any = this.utilityServ.getArray(
                            data.Envelope.Body.BeneficiariesResponse.Beneficiaries
                                .BeneficiaryDetail
                        );
                        const uServ = this.utilityServ;
                        const countryPreference = this.sendMoneyDetail.pickupTypeDetails
                            .countryPreference;
                        this.beneficiaryList = arrlist.filter(function (item) {
                            return (
                                uServ.getObjectText(item.Addresses.CountryCode) ==
                                countryPreference
                            );
                        });
                    }
                },
                error => { }
            );
    }

    editBeneficiary(BeneficiaryData) {
        const bd: BeneficiaryDetails = new BeneficiaryDetails();

        bd.AdditionalLastName = this.utilityServ.getObjectText(
            BeneficiaryData.AdditionalLastName
        );
        bd.address = this.utilityServ.getObjectText(
            BeneficiaryData.Addresses.Address1
        );
        bd.city = this.utilityServ.getObjectText(
            BeneficiaryData.Addresses.CityCode
        );
        bd.state = this.utilityServ.getObjectText(
            BeneficiaryData.Addresses.StateCode
        );
        bd.country = this.utilityServ.getObjectText(
            BeneficiaryData.Addresses.CountryCode
        );
        bd.zipCode = this.utilityServ.getObjectText(
            BeneficiaryData.Addresses.ZipCode
        );

        bd.BeneficiaryId = this.utilityServ.getObjectText(
            BeneficiaryData.BeneficiaryId
        );
        bd.Checksum = this.utilityServ.getObjectText(BeneficiaryData.Checksum);
        bd.EmailAddress = this.utilityServ.getObjectText(
            BeneficiaryData.EmailAddress
        );
        bd.FirstName = this.utilityServ.getObjectText(BeneficiaryData.FirstName);
        bd.IdentificationNumber = this.utilityServ.getObjectText(
            BeneficiaryData.IdentificationNumber
        );
        bd.IdentificationType = this.utilityServ.getObjectText(
            BeneficiaryData.IdentificationType
        );
        bd.LastName = this.utilityServ.getObjectText(BeneficiaryData.LastName);
        bd.MiddleName = this.utilityServ.getObjectText(BeneficiaryData.MiddleName);
        bd.NickName = this.utilityServ.getObjectText(BeneficiaryData.NickName);
        bd.Phone = this.utilityServ.getObjectText(BeneficiaryData.Phone);
        bd.Relationship = this.utilityServ.getObjectText(
            BeneficiaryData.Relationship
        );
        bd.callType = "edit";

        this.sendMoneyService.setBeneficiaryData(bd);
        const parent = this;
        this.modal.overlay.defaultViewContainer = this.vcRef;
        return this.modal
            .open(
                AddEditBeneficiaryComponent,
                overlayConfigFactory({ bd }, BSModalContext)
            )
            .then(function (obj) {
                obj.onDestroy.subscribe(data => {
                    parent.Init();
                });
            });
    }
    addBeneficiary() {
        // this.router.navigate(['/addbeneficiary']);
        const bd: BeneficiaryDetails = new BeneficiaryDetails();
        bd.callType = "add";
        const parent = this;
        this.modal.overlay.defaultViewContainer = this.vcRef;
        return this.modal
            .open(
                AddEditBeneficiaryComponent,
                overlayConfigFactory({ bd }, BSModalContext)
            )
            .then(function (obj) {
                obj.onDestroy.subscribe(data => {
                    parent.Init();
                });
            });
    }

    valueChangeForward(isFirstLoad: boolean = false) {

        if (isFirstLoad == true) {

            this.model.srcAmount = this.paymentDetails.srcAmount.toFixed(AppSettings.fractionDigit);
            this.model.destAmount = this.paymentDetails.destAmount.toFixed(this.RoundingPlaces || AppSettings.fractionDigit);

        } else {

            this.calculateFromLocalAmount(Number(this.model.srcAmount || 0));

            this.loadBranchDetail();

            let subscription = this.observable.subscribe(branchInfoChanged => {

                if (subscription != undefined) {
                    subscription.unsubscribe();
                }

                if (branchInfoChanged === true) {
                    this.calculateFromLocalAmount(Number(this.model.srcAmount || 0));
                }

                this.sendMoneyService.setSendMoneyDetailData(this.sendMoneyDetail);
                this.isAmountExceed(this.paymentDetails.srcAmount);

            });
        }
    }

    private calculateFromLocalAmount(localAmount: number) {

        let maxAllowedLimit = this.paymentDetails.maxAllowedLimit;
        maxAllowedLimit = maxAllowedLimit != null && maxAllowedLimit !== undefined && !isNaN(maxAllowedLimit) ? maxAllowedLimit : 0;

        if (maxAllowedLimit > 0 && localAmount > maxAllowedLimit) {
            localAmount = maxAllowedLimit;
        }

        return this.calculateFromTransferAmount(localAmount * this.Rate);

    }

    valueChangeBackward() {

        this.calculateFromTransferAmount(Number(this.model.destAmount || 0));

        this.loadBranchDetail();

        let subscription = this.observable.subscribe(branchInfoChanged => {

            if (subscription != undefined) {
                subscription.unsubscribe();
            }

            if (branchInfoChanged === true) {
                this.calculateFromTransferAmount(Number(this.model.destAmount || 0));
            }

            this.sendMoneyService.setSendMoneyDetailData(this.sendMoneyDetail);
            this.isAmountExceed(this.paymentDetails.srcAmount);

        });
    }

    private calculateFromTransferAmount(transferAmount: number) {

        let maxAllowedLimit = this.paymentDetails.maxAllowedLimit;
        maxAllowedLimit = maxAllowedLimit != null && maxAllowedLimit !== undefined && !isNaN(maxAllowedLimit) ? maxAllowedLimit : 0;

        if (maxAllowedLimit > 0) {
            transferAmount = (transferAmount / this.Rate) <= maxAllowedLimit ? transferAmount : maxAllowedLimit * this.Rate;
        }

        let minimumDenomination = this.paymentDetails.minimumDenomination;

        if (minimumDenomination > 0) {

            let ceilTransferAmount = Math.ceil(transferAmount / minimumDenomination) * minimumDenomination;
            let floorTransferAmount = Math.floor(transferAmount / minimumDenomination) * minimumDenomination;

            if (maxAllowedLimit > 0) {
                transferAmount = (ceilTransferAmount / this.Rate) <= maxAllowedLimit ? ceilTransferAmount : floorTransferAmount;
            } else {
                transferAmount = ceilTransferAmount;
            }
        }

        let localAmount = transferAmount / this.Rate;

        this.model.srcAmount = localAmount.toFixed(AppSettings.fractionDigit);
        this.model.destAmount = transferAmount.toFixed(this.RoundingPlaces || AppSettings.fractionDigit);
        //console.log("tax", this.TaxAmount)
        this.paymentDetails.srcAmount = localAmount;
        this.paymentDetails.destAmount = Number(transferAmount.toFixed(this.RoundingPlaces || AppSettings.fractionDigit));
        this.paymentDetails.totalAmount = Number(localAmount.toFixed(AppSettings.fractionDigit)) + Number(this.Fee) + Number(this.TaxAmount);
        this.sendMoneyDetail.paymentDetails = this.paymentDetails;

    }


    isAmountExceed(amount: number) {
        let flag = true;
        let maxAllowedLimit = this.paymentDetails.maxAllowedLimit;
        maxAllowedLimit = maxAllowedLimit != null && maxAllowedLimit !== undefined && !isNaN(maxAllowedLimit) ? maxAllowedLimit : 0;
        // amount = amount + this.Fee;
        if (maxAllowedLimit == 0) {
            flag = false;
        } else {
            flag = amount > maxAllowedLimit ? true : false;
        }
        if (flag) {
            const modalData: any = {};
            modalData.Title = this.translate.instant("Common_lblInfo").toString();
            modalData.Message = this.translate.instant("InputAmount_amountExceedPre") + " " + this.paymentDetails.srcCurrCode + " " + parseFloat(this.paymentDetails.maxAllowedLimit.toString()) + " " + this.translate.instant("InputAmount_amountExceedPost");
            modalData.Action = this.translate.instant("Common_lblOk").toString();
            if (this.isModalOpen == false) {
                this.isModalOpen = true;
                const _self = this;
                this.modal.overlay.defaultViewContainer = this.vcRef;
                this.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
                    obj.onDestroy.subscribe(data => {
                        _self.isModalOpen = false;
                    });
                });
            }

            return true;
        } else {
            return false;
        }
    }


    timeout: any = null;
    public onKeySearch(event: any) {

        let _localAmtChanged = this.LocalAmountChanged()
        let _transferAmtChanged = this.TransferAmountChanged()

        if (_localAmtChanged || _transferAmtChanged) {

            clearTimeout(this.timeout);

            this.srcRadio = _localAmtChanged;
            this.dstRadio = _transferAmtChanged;

            var $this = this;

            $this.timeout = setTimeout(function () {

                if ((_localAmtChanged && !$this.model.srcAmount || isNaN($this.model.srcAmount)) || (_transferAmtChanged && !$this.model.destAmount || isNaN($this.model.destAmount))) {
                    $this.model.srcAmount = '0.00';
                    $this.model.destAmount = '0.00';
                    $this.paymentDetails.srcAmount = 0.00;
                    $this.paymentDetails.destAmount = 0.00;
                    $this.paymentDetails.totalAmount = 0.00;
                } else {

                    $this.TriggerAmountChanged();

                }

            }, 2000);
        }
    }

    private TriggerAmountChanged() {

        if (this.srcRadio === true) {
            this.valueChangeForward();
        }

        if (this.dstRadio === true) {
            this.valueChangeBackward();
        }
    }

    private LocalAmountChanged() {
        return this.AmountChanged(this.model.srcAmount, this.paymentDetails.srcAmount, 2);
    }

    private TransferAmountChanged() {
        return this.AmountChanged(this.model.destAmount, this.paymentDetails.destAmount, this.RoundingPlaces || 2);
    }

    private AmountChanged(_newAmount: any, _oldAmount: any, precision: number) {

        let _newAmountNumber: any = Number(_newAmount);
        let _oldAmountNumber: any = Number(_oldAmount);

        if (!isNaN(_newAmountNumber)) {
          _newAmountNumber = _newAmountNumber.toFixed(precision);
        }

        if (!isNaN(_oldAmountNumber)) {
          _oldAmountNumber = _oldAmountNumber.toFixed(precision);
        }

        if (isNaN(_newAmountNumber) && isNaN(_oldAmountNumber)) {
            return _newAmount !== _oldAmount;
        } else {
            return _newAmountNumber !== _oldAmountNumber;
        }
    }

    isValidDenomination(amount: number) {
        //console.log("valid denomination called from beneficiary component");
        let denomination = this.paymentDetails.minimumDenomination;
        denomination = denomination != null && denomination !== undefined && !isNaN(denomination) ? denomination : 0;
        if (denomination == 0) {
            return true;
        }
        if (amount % denomination == 0) {
            return true;
        } else {
            const modalData: any = {};
            modalData.Title = this.translate.instant("Common_lblInfo").toString();
            modalData.Message = this.translate.instant("InputAmount_errorDenominationDesc") + " " + denomination;
            this.modal.overlay.defaultViewContainer = this.vcRef;
            this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
            return false;
        }
    }

    beneficiaryInit(BeneficiaryData) {
        if (this.paymentDetails.srcAmount <= 0) {
            //console.log("source amount less than or equal zero");
            const modalData: any = {};
            modalData.Title = this.translate.instant("AddToCartSuccess_title").toString();
            modalData.Message = this.translate.instant("Common_lblAmountZero").toString();
            this.modal.overlay.defaultViewContainer = this.vcRef;
            this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
            return false;
        }
        if (this.paymentDetails.destAmount <= 0) {
            //console.log("destination amount less than or equal zero");
            const modalData: any = {};
            modalData.Title = this.translate.instant("AddToCartSuccess_title").toString();
            modalData.Message = this.translate.instant("Common_lblDestinationAmountZero ").toString();
            this.modal.overlay.defaultViewContainer = this.vcRef;
            this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
            return false;
        }

        if (this.isAmountExceed(this.paymentDetails.srcAmount) || !this.isValidDenomination(this.paymentDetails.destAmount)) {
            return false;
        }
    }
    // formatAmount(event) {
    //   event.currentTarget.value = this.currencyPipe.parse(event.currentTarget.value); // event.currentTarget.value.replace('$', '');
    // }
    formatAmount(event) {
        event.currentTarget.value = this.amountFormat.transform(event.currentTarget.value); // this.amountFormat.transform(event.currentTarget.value); // event.currentTarget.value.replace('$', '');
    }

    revformatAmount(event) {
        event.currentTarget.value = event.currentTarget.value.replace(/[^0-9-.]/g, "");
        event.currentTarget.value = Number(event.currentTarget.value) == 0 ? "" : event.currentTarget.value;
    }
    retAmount(amount) {
        const val = amount.replace(/[^0-9-.]/g, "");
        return parseFloat(Number(val).toFixed(AppSettings.fractionDigit));
    }

    Clickbeneficiary(beneficiaryData) {

        if (this.LocalAmountChanged() || this.TransferAmountChanged()) {

            clearTimeout(this.timeout);

            this.srcRadio = this.LocalAmountChanged();
            this.dstRadio = this.TransferAmountChanged();

            this.TriggerAmountChanged();

            let subscription = this.observable.subscribe(() => {

                if (subscription != undefined) {
                    subscription.unsubscribe();
                }

                this.beneficiaryRowClick(beneficiaryData);

            });
        } else {
            this.beneficiaryRowClick(beneficiaryData);
        }
    }

    beneficiaryRowClick(beneficiaryData) {
        const _self = this;
        const modalData: any = {};
        modalData.page = this.translate.instant("Common_lblInfo");

        // below code just for testing thats why its commented out-
        // this.sendMoneyDetail.userDetails = new User();
        // this.sendMoneyDetail.beneficiaryDetails = new BeneficiaryDetails();
        this.sendMoneyDetail.beneficiaryDetails = beneficiaryData;
        if (_self.beneficiaryInit(beneficiaryData) == false) {
            return false;
        }
        if (_self.isMissingAnyAdditionalInfo(_self.sendMoneyDetail.userDetails, _self.sendMoneyDetail.beneficiaryDetails, _self.sendMoneyDetail.branchDetails.Validation)) {
            return _self.modal.open(AdditionalInfoPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
                obj.onDestroy.subscribe(data => {
                    if (modalData.onNext == "yes") {
                        _self.gotoPayment();
                    }
                });
            });
        } else {
            const model = _self.sendMoneyService.initUserBeneficiaryDataFromSendmoneyObject(_self.sendMoneyDetail, "paymenttype");
            _self.utilityServ.busy = _self.sendMoneyService.saveMissingInfo(model, false).subscribe(data => {
                if (data.Envelope.Body.MissingInformationResponse.StatusCode == 20001) {
                    return false;
                } else if (data.StatusCode == -10000) {
                    const modalData: any = {};
                    modalData.Title = _self.translate.instant("Common_lblOops").toString();
                    modalData.Message = _self.translate.instant("Message_errorMessage").toString();
                    return _self.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
                } else if (data.Envelope.Body.MissingInformationResponse.StatusCode == enumStatusCodeList.SUCCESS) {
                    _self.gotoPayment();
                } else {
                    const modalData: any = {};
                    modalData.Title = _self.translate.instant("Common_lblOops").toString();
                    modalData.Message = _self.translate.instant("Message_errorMessage").toString();
                    return _self.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
                        obj.onDestroy.subscribe(data => {
                            if (modalData.next == "yes") {
                            }
                        });
                    });
                }
            },
                error => { }
            );
        }
    }

    loadBranchDetail() {
        this.sendMoneyDetail.agentDetails.Amount = this.sendMoneyDetail.paymentDetails.srcAmount;
        //console.log("Es el 3");
        this.utilityServ.busy = this.sendMoneyService.getBranchDetails(this.sendMoneyDetail.agentDetails).subscribe(
            data => {
                if (data.StatusCode == 10000 && data.Branches != null) {
                    //console.log("valores", Number(this.paymentDetails.exchangeRate), Number(data.Branches[0].RateCustomer), Number(this.paymentDetails.processingFee), Number(data.Branches[0].CustomerFee))
                    if (Number(this.paymentDetails.exchangeRate) != Number(data.Branches[0].RateCustomer) || Number(this.paymentDetails.processingFee) != Number(data.Branches[0].CustomerFee) || Number(this.paymentDetails.TaxAmount) != Number(data.Branches[0].TaxAmount)) {
                        this.sendMoneyDetail.branchDetails = data.Branches[0];
                        this.sendMoneyDetail.branches = data.Branches;

                        this.paymentDetails.processingFee = parseFloat(this.sendMoneyDetail.branchDetails.CustomerFee.toString());
                        this.paymentDetails.TaxAmount = parseFloat(this.sendMoneyDetail.branchDetails.TaxAmount.toString());
                        this.paymentDetails.exchangeRate = this.sendMoneyDetail.branchDetails.RateCustomer.toString();
                        this.Rate = parseFloat(this.paymentDetails.exchangeRate);
                        this.Fee = this.paymentDetails.processingFee;
                        this.TaxAmount = this.paymentDetails.TaxAmount;
                        //console.log("el otro tax", this.TaxAmount)
                        if (this.sendMoneyDetail.branchDetails.MinimumDenomination != null) {
                            this.paymentDetails.minimumDenomination = parseFloat(this.sendMoneyDetail.branchDetails.MinimumDenomination.toString());
                        } else {
                            this.paymentDetails.minimumDenomination = 0;
                        }

                        if (this.sendMoneyDetail.branchDetails.MaximumLocalAmount != null) {
                            this.paymentDetails.maxAllowedLimit = parseFloat(this.sendMoneyDetail.branchDetails.MaximumLocalAmount.toString());
                        } else {
                            this.paymentDetails.maxAllowedLimit = 0;
                        }

                        if (!this.sendMoneyDetail.branchDetails.MaximumLocalAmountExcludeFee && this.paymentDetails.maxAllowedLimit > 0) {
                            this.paymentDetails.maxAllowedLimit = this.paymentDetails.maxAllowedLimit - this.Fee;
                        }

                        if (this.paymentDetails.maxAllowedLimit == 0 || this.paymentDetails.maxAllowedLimit > parseFloat(this.sendMoneyDetail.userDetails.maxTransferAmountLimit)) {
                            this.paymentDetails.maxAllowedLimit = parseFloat(this.sendMoneyDetail.userDetails.maxTransferAmountLimit);
                        }

                        this.sendMoneyService.setSendMoneyDetailData(this.sendMoneyDetail);
                        // return true;
                        //this.valueChangeForward();
                        // if (this.actionFlag) {
                        this.clickStream.next(true);
                        // }
                    } else {
                        // return false;
                        // if (this.actionFlag) {
                        this.clickStream.next(false);
                        // }
                    }
                } else {
                    const _self = this;
                    let modalData: any = {};
                    modalData.Action = this.translate.instant('Common_lblOk');
                    modalData.Title = this.translate.instant('Common_lblOops').toString();
                    modalData.Message = this.translate.instant('Message_errorMessage').toString();
                    this.modal.overlay.defaultViewContainer = this.vcRef;
                    return this.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
                        obj.onDestroy.subscribe(data => {
                            //console.log('Observer got a next value: ' + data);
                            if (modalData.next == 'yes') {
                                _self.sendMoneyService.setDeactivateSummaryFlag(true);
                                _self.router.navigate(['/dashboard']);
                            }
                        });
                    });
                }
            },
            error => {
                //console.log('Observer got a next value: ' + error);
            }
        );
    }

    gotoPayment() {
        this.userDetails();
        const _self = this;
        const unsubUserDetails = this.observableUserDetails.subscribe(x => {
            if (x == true) {
                const usnsubUserDetailData = _self.userStateService
                    .getcurrentUserDetailData()
                    .subscribe(data => {
                        _self.sendMoneyDetail.userDetails = data;
                        _self.sendMoneyDetail.paymentDetails = _self.paymentDetails;
                        _self.sendMoneyService.setSendMoneyDetailData(
                            _self.sendMoneyDetail
                        );
                        _self.sendMoneyService.setModalPopup(SendMoneySteps.PaymentType);
                        if (usnsubUserDetailData != undefined) {
                            usnsubUserDetailData.unsubscribe();
                        }
                    });
            }
            if (unsubUserDetails != undefined) {
                unsubUserDetails.unsubscribe();
            }
        });
    }
    isMissingAnyAdditionalInfo(
        userDetails: User,
        beneficiaryDetails: BeneficiaryDetails,
        _additionalRequiredFields: AdditionalRequired
    ) {
        let isMissingAdditionalInfo: Boolean = false;

        // Customer DOB
        if (userDetails.dob.length == 0) {
            isMissingAdditionalInfo = true;
        }

        // Customer Country, State and City
        if (userDetails.country.length == 0) {
            isMissingAdditionalInfo = true;
        }

        // Customer Address
        if (userDetails.address.length == 0) {
            isMissingAdditionalInfo = true;
        }
        // Customer Zip
        if (userDetails.zipcode.length == 0) {
            isMissingAdditionalInfo = true;
        }
        // Customer Occupation
        if (
            userDetails.occupation.length == 0 &&
            _additionalRequiredFields.IsCustomerOccupationRequired
        ) {
            isMissingAdditionalInfo = true;
        }
        // Customer Employer
        if (
            userDetails.employess.length == 0 &&
            _additionalRequiredFields.IsCustomerEmployerRequired
        ) {
            isMissingAdditionalInfo = true;
        }
        // beneficiary middle name
        if (
            beneficiaryDetails.AdditionalLastName.length == 0 &&
            _additionalRequiredFields.isBeneficiaryLastName2Required
        ) {
            isMissingAdditionalInfo = true;
        }
        // beneficiary phone number
        if (
            this.utilityServ.getObjectText(beneficiaryDetails.Phone).length == 0 &&
            _additionalRequiredFields.IsBeneficiaryPhoneRequired
        ) {
            isMissingAdditionalInfo = true;
        }
        // beneficiary country, state and city
        if (
            this.utilityServ.getObjectText(beneficiaryDetails.Addresses.StateCode)
                .length == 0
        ) {
            isMissingAdditionalInfo = true;
        }
        // beneficiary address
        if (
            this.utilityServ.getObjectText(beneficiaryDetails.Addresses.Address1)
                .length == 0 &&
            _additionalRequiredFields.IsBeneficiaryAddressRequired
        ) {
            isMissingAdditionalInfo = true;
        }
        // beneficiary zip code
        if (
            this.utilityServ.getObjectText(beneficiaryDetails.Addresses.ZipCode)
                .length == 0 &&
            _additionalRequiredFields.IsBeneficiaryZipCodeRequired
        ) {
            isMissingAdditionalInfo = true;
        }
        // beneficiary relation ship
        if (
            this.utilityServ.getObjectText(beneficiaryDetails.Relationship).length ==
            0 &&
            _additionalRequiredFields.IsBeneficiaryRelationRequired
        ) {
            isMissingAdditionalInfo = true;
        }
        // beneficiary identification Number
        if (
            this.utilityServ.getObjectText(beneficiaryDetails.IdentificationNumber)
                .length == 0 &&
            _additionalRequiredFields.IsBeneficiaryIdentificationRequired
        ) {
            isMissingAdditionalInfo = true;
        }
        // Transfer Reason Required
        if (_additionalRequiredFields.IsTransferReasonRequired) {
            isMissingAdditionalInfo = true;
        }
        // Fund Source Required
        if (_additionalRequiredFields.IsFundSourceRequired) {
            isMissingAdditionalInfo = true;
        }
        return isMissingAdditionalInfo;
    }
    userDetails() {
        const _self = this;
        this.utilityServ.busy = this.auth.getUserDetail().subscribe(
            data => {
                const resJSON = data;
                if (
                    resJSON.Envelope.Body.CustomerInfoResponse.StatusCode ==
                    enumStatusCodeList.SUCCESS
                ) {
                    _self.auth.setUserDetails(resJSON);
                    sessionStorage.UserData = this.utilityServ.AESEncrypt(
                        JSON.stringify(resJSON)
                    );
                    this.subUserDetails.next(true);
                } else {
                    this.subUserDetails.next(false);
                }
            },
            error => { }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/sendMoney/beneficiary/beneficiary.component.ts